import { useState } from "react";
import type { FormatoExport } from "./exportar-tabela";

export type PreferenciasDeExportacao = {
  formato: FormatoExport;
  /** Títulos na ordem escolhida; coluna nova (que não estava aqui) entra no fim. */
  ordem: string[];
  ocultas: string[];
  incluirId: boolean;
};

const PADRAO: PreferenciasDeExportacao = { formato: "xlsx", ordem: [], ocultas: [], incluirId: false };
const chaveDe = (tela: string) => `bookdental.exportar.${tela}`;

function ler(tela: string): PreferenciasDeExportacao {
  try {
    const salvo = window.localStorage.getItem(chaveDe(tela));
    return salvo ? { ...PADRAO, ...(JSON.parse(salvo) as Partial<PreferenciasDeExportacao>) } : PADRAO;
  } catch {
    return PADRAO;
  }
}

/** O que a pessoa escolheu na última exportação desta tela: formato, colunas, ordem e o ID. */
export function usePreferenciasDeExportacao(tela: string) {
  const [prefs, setPrefs] = useState<PreferenciasDeExportacao>(() => ler(tela));

  const mudar = (parcial: Partial<PreferenciasDeExportacao>) =>
    setPrefs((atual) => {
      const proximas = { ...atual, ...parcial };
      try {
        window.localStorage.setItem(chaveDe(tela), JSON.stringify(proximas));
      } catch {
        // Sem armazenamento (aba anônima, bloqueio): vale só até fechar a tela.
      }
      return proximas;
    });

  return { prefs, mudar, restaurar: () => mudar({ ordem: [], ocultas: [] }) };
}

/** As colunas que a tela oferece, na ordem salva — as que a tela ganhou depois entram no fim. */
export function ordenarTitulos(titulos: string[], ordem: string[]): string[] {
  const conhecidos = ordem.filter((t) => titulos.includes(t));
  return [...conhecidos, ...titulos.filter((t) => !conhecidos.includes(t))];
}
